import { iStoreCaseConfiguration } from '@/Interfaces/storeCaseConfiguration';
import { colors } from '@/Constants/colors';

// https://www.safe.ru/products/shkaf-instrumentalnyy-ts-1995-004030/
export const tc_1995_004030: Omit<iStoreCaseConfiguration & { name: string }, 'itemsFromApi'>  = {
    id: 'b9a6b56d-3caf-46a9-90fb-81189492d6f7',
    name: '004030',
    selectedCaseModel: 'TC-1995',
    selectedCasePresetId: 'b4fbe2e4-b79a-401e-86d3-63ed745a0e18',
    blenderName: 'tc_1995',
    colorFrame: colors[0].hex,
    colorFace: colors[1].hex,
    image: 'dist/src/img/presets/image_1.png',
    caseItems : [ {
        id: 'a880fbb9-19fc-4498-9b7c-e59017d7126c',
        prototypeId: 'tcsh_95x47',
        indexPositionY: 14,
        isLeft: false,
    }, {
        id: '1dfac217-6b35-4558-aca6-23285fd33b54',
        prototypeId: 'tcsh_95x47',
        indexPositionY: 22,
        isLeft: false,
    }, {
        id: '10b4e5f8-bee3-4507-8faf-e23d7be5c2d9',
        prototypeId: 'tcsh_95x47',
        indexPositionY: 35,
        isLeft: false,
    }, {
        id: '7ed5bf2c-35cd-4073-b5ce-c33632bb9028',
        prototypeId: 'tcsh_95x47',
        indexPositionY: 47,
        isLeft: false,
    }, {
        id: 'd2d46dac-0b47-4fc4-b727-b669e73ef475',
        prototypeId: 'tcf_87x45',
        indexPositionY: 0,
        isLeft: false,
    },{
        id: 'cc2bde5a-3962-4a0a-9be8-4c3dd4ce4814',
        prototypeId: 'tcf_87x45',
        indexPositionY: 1,
        isLeft: false,
    }, {
        id: '1688db09-aec4-4e02-8863-4a2b8e5fc1e3',
        prototypeId: 'tcf_87x45',
        indexPositionY: 2,
        isLeft: false,
    },
    ],
    drawerSeparators: [],
    expandedDrawersPrototypeId: [],
};
